const initialState = {
  customReports: [],
  isFetchingCustomReports: false,
  rowIndexToScrollTo: null,

  openFormForEdit: false,
  openFormForAdd: false,
  readOnly: false,
  customReportToEditId: null,

  isFetchingCustomReportParams: false,
  customReportParams: null,

  isTestCustomReportQueryInProgress: false,
  customReportData: null,

  isSavingCustomReportQueryInProgress: false,

  reportParamToEditOptions: [],
  isVerifyingParamToEditQuery: false,

  isDeletingInProgress: false,
};

export default initialState;
